import styled, { css } from 'styled-components';

import IllustrationThumb from 'components/IllustrationThumb';
import { COLOR_GRAY_50 } from 'styles/variables/colors';
import { ThumbsPosition } from './types';

export const Container = styled.div`
  margin-bottom: 27px;

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    gap: 20px;
  }
`;

export const Main = styled.div`
  @media (min-width: 768px) {
    order: 2;
    flex: 1 1 auto;
    max-width: 520px;
    max-height: 520px;
  }

  ${(props) =>
    props.position === ThumbsPosition.Bottom &&
    css`
      margin-bottom: 17px;
    `}
`;

export const Image = styled(IllustrationThumb)`
  flex: 1 1 auto;
  margin: 0;
  width: 100%;

  & img {
    height: 88px;
    width: 100%;
  }

  ${(props) =>
    !props.isMain &&
    css`
      border-radius: 0;
    `}

  ${(props) =>
    props.isActive &&
    css`
      box-shadow: 0 0 0 2px ${COLOR_GRAY_50};
      border-color: transparent;

      &:hover {
        border-color: transparent;
      }
    `}

  ${(props) =>
    props.isMain &&
    css`
      height: 100%;

      & img {
        width: 100%;
        height: 100%;
      }

      @media (min-width: 768px) {
        min-height: 410px;
      }
    `}
`;

export const Thumbs = styled.div`
  display: flex;

  @media (min-width: 768px) {
    order: 1;
    flex-direction: column;
    justify-content: flex-start;
    margin-right: 17px;
    width: 115px;
    height: 115px;

    & ${Image} {
      flex: 0 1 auto;
      margin: 0;
      margin-bottom: 17px;
      width: 100%;
    }

    ${(props) =>
      props.position === ThumbsPosition.Bottom &&
      css`
        order: 2;
        flex-direction: row;
        margin: 0;
        overflow: auto;
        flex: 1 1 auto;
        min-width: 100%;
        padding: 2px 0 2px 2px;
        margin-left: -2px;

        & ${Image} {
          min-width: 130px;
          max-width: 130px;
          margin: 0 17px 0 0;
          flex: 1 1 auto;
        }
      `}
  }
`;
